import Layout from "@/layout/index.vue";

export default [
  {
    path: "/",
    redirect: '/init'
  },
  {
    path: "/chat",
    name: "Layout",
    component: Layout,
    redirect: "/chat",
    children: [
      {
        path: '/chat',
        name: "chat",
        meta: { keepAlive: true, isHead: false },
        component: () => import("@/views/chat/index.vue")
      },
      {
        path: '/web-view/:url',
        name: "web-view",
        meta: { isHead: false },
        component: () => import("@/views/web-view/index.vue"),
      },
      {
        path: "/map-view",
        name: "map-view",
        meta: { isHead: true,  title: 'route.展商地图', },
        component: () => import("@/views/map-view/index.vue"),
      },
      // 此方式路由缓存不好控制
      // {
      //   path: "/details/:type",
      //   name: "DetailsPage",
      //   meta: { isHead: false, title: 'route.详情' },
      //   component: () => import("@/views/details/index.vue"),
      // },
      {
        path: "/details/exhibitor",
        name: "exhibitor",
        meta: { isHead: false, title: 'route.详情' },
        component: () => import("@/views/details/exhibitor.vue"),
      },
      {
        path: "/details/exhibit",
        name: "exhibit",
        meta: { isHead: false, title: 'route.详情' },
        component: () => import("@/views/details/exhibit.vue"),
      },
      {
        path: "/details/meeting",
        name: "meeting",
        meta: { isHead: false, title: 'route.详情' },
        component: () => import("@/views/details/meeting.vue"),
      },
      {
        path: "/details/oppty",
        name: "oppty",
        meta: { isHead: false, title: 'route.详情' },
        component: () => import("@/views/details/oppty.vue"),
      },
      {
        path: "/settings",
        name: "settings",
        meta: { isHead: false, title: 'route.小助手设定' },
        component: () => import("@/views/settings/index.vue"),
      },
    ],
  },
  // 加载页
  {
    path: '/init',
    name: "init",
    meta: { },
    component: () => import("@/views/init/index.vue"),
  },
  // 错误页
  {
    path: '/error/:type',
    name: "error",
    meta: { },
    component: () => import("@/views/error/index.vue"),
  },
  // 兜底匹配：所有未命中路由 → 404 页面
  // 必须放在最后，否则会吞掉 /error/:type 等已有路由
  {
    path: '/:pathMatch(.*)*',
    name: "not-found",
    meta: { title: "404" },
    component: () => import("@/views/error/common/404.vue"),
  },
]